import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseFormGroup } from '../../shared/form-input-components/base-form-group';
import { CommonService } from '../../shared/services/common.service';
import { UtilService } from '../../shared/services/util.service';
import { CommonBookingService } from '../shared/common-booking.service';
import { CreateBookingService } from './create-booking.service';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import { DrawerService } from 'mis-crystal-design-system/drawer';
import { BookingInstructionComponent } from 'src/app/shared/components/booking-instruction/booking-instruction.component';


@Component({
  selector: 'app-create-booking',
  templateUrl: './create-booking.component.html',
  styleUrls: ['./create-booking.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {showError: true}
  }]
})

export class CreateBookingComponent extends BaseFormGroup implements OnInit, OnDestroy {
  @ViewChild('stepper') private myStepper: MatStepper;
  public activeStep = 0;
  public isLoading: boolean;
  public loadingError: boolean;
  public isExitPopupVisible = false;

  public stepperDetails: any[];
  public formDetails: FormGroup;
  public uploadedDocuments: any[] = [];
  public bookingCreationCutoff: any;
  public cutoff: any;
  public bookingCutoffMessage: string;
  public isNoRiderErrorVisible: boolean;
  private startRiderConfig: any[];
  public isBookingCreationError: boolean;
  public bookingCreationErrorMsg: string;
  public stepperReference: FormArray;
  public config: any;
  private filteredConfig: any;
  private referenceBooking: any;
  public bookingEditConfig: any;
  public isEditMode: boolean;
  public showErrorMsg: boolean;
  public paymentType;
  public selectedPayerEmail;
  public loggedInUserEmail;
  public showAddButton: boolean;
  public showDiffPayerButton: boolean;
  designationConfig: any;
  private destroy$ = new Subject();
  approvalEmail = "";
  dialogOpen: boolean;
  managerApprovalRequired = false;
  requester = 'self';
  billing_type = 'bill_to_company';
  isLinear = true;
  showConfirmBookingPopup = false;
  customReportingManager = false;
  customManagerPopup = false;
  managerBookingPopup = false;
  preponeTripSheetInHours = '';
  guardReq = false;
  reqRiderDropdown: any;
  miscellConfig: any;
  escortConfig: any;
  showEngagementPopover: boolean = false;
  isAllGuest: boolean = false;

  engagementForm: FormGroup = new FormGroup({
    billableType: new FormControl(),
    manager: new FormControl(),
    partner: new FormControl(),
    gstCode: new FormControl()
  })

  constructor(
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private commonBookingService: CommonBookingService,
    private router: Router,
    private createBookingService: CreateBookingService,
    private authService: AuthService,
    private location: Location,
    private utilService: UtilService,
    private formBuilder: FormBuilder,  private drawerSvc: DrawerService) {
    super();
  }

  setupForm(formDetails?: FormGroup) {
    this.formDetails = formDetails || new FormGroup({
      userDetails: new FormGroup({}),
      tripDetails: new FormGroup({})
    });
    this.stepperReference = new FormArray([
      this.formDetails.get('userDetails'),
      this.formDetails.get('tripDetails')
    ]);


    if(this.miscellConfig?.verifyEngagementCode && this.createBookingService.isEditMode){
      this.engagementForm.get('billableType').setValue(this.referenceBooking?.billableType || null);
      this.engagementForm.get('gstCode').setValue(this.referenceBooking?.gstCode || null);    
    }
    // this.paymentType = this.formDetails.get('userDetails').value["requester"]["paymentType"] ===
    // 'Bill To Company' ? 'Bill To Company' : 'Bill To User'

  }

  ngOnInit() {

    this.createBookingService.getRequesters().subscribe(res => {
      this.reqRiderDropdown = Object.keys(res.value).map((key) => ({ label: key, value: res.value[key] }));
    });

    window.scroll(0, 0);
    if (!this.commonService.workflowConfig) {
      this.commonService.fetchWorkflowConfig().subscribe((response) => {
        this.commonService.workflowConfig = response;
      });
    }

    this.miscellConfig = this.commonService.miscConfig;
    this.createBookingService.approverEmail.
      pipe(takeUntil(this.destroy$)).
      subscribe((res: string) => {
        this.approvalEmail = res;
      });

    this.createBookingService.showdialog.
      pipe(takeUntil(this.destroy$)).
      subscribe((res: boolean) => {
        this.dialogOpen = res;
      });

    this.createBookingService.managerApprovalRequired.
      pipe(takeUntil(this.destroy$)).
      subscribe((res: boolean) => {
        this.managerApprovalRequired = res;
      });

    if (this.router.url.indexOf('bookings/edit') > - 1) {
      this.createBookingService.isEditMode = true;
      this.isEditMode = true;
      this.commonService.fetchEditConfig().subscribe(this.handleCutoffResponse);
    } else {
      if (this.miscellConfig?.enableCityWiseCreationCutOff) {
      this.commonService.fetchCityCutoff().subscribe(this.handleCutoffResponse);
      }
      else {
      this.commonService.fetchCutoff().subscribe(this.handleCutoffResponse);
      }
    }
    this.createBookingService.newRiders = [];
    this.commonService.fetchCabTypeConfig().subscribe((response) => {
      this.designationConfig = response;
    });
    this.createBookingService.fetchEscortConfig().subscribe(res => {
      this.escortConfig = res;
      this.preponeTripSheetInHours = res[0].preponeTripSheetInHours;
      this.createBookingService.preponeTripSheetInHours.next(res[0].preponeTripSheetInHours);
      this.createBookingService.startTime.next(res[0].escortAssigGenderConfig[0].escortAssigTimeConfig.startTime);
      this.createBookingService.endTime.next(res[0].escortAssigGenderConfig[0].escortAssigTimeConfig.endTime);
      this.createBookingService.genderArrays.next(res[0].escortAssigGenderConfig[0].gender);
      this.createBookingService.escortConfig.next(res[0]);
       });
  }

  handleCutoffResponse = (response) => {
       this.bookingCreationCutoff = this.cutoff = response;
       if (this.cutoff && !this.utilService.checkIfDateTimeBetween(this.cutoff.start, this.cutoff.end)) {
      this.bookingCutoffMessage = this.cutoff.errorMessage;
    } else {
      this.setupComponent();
    }
  }

  closeBookingCutoff() {
    if (this.activeStep === 0) {
      this.router.navigate(['bookings']);
    } else if (this.activeStep === 2) {
      this.bookingCutoffMessage = '';
    }
  }

  setupComponent() {
    this.isLoading = true;
    this.commonService.fetchConfig().subscribe((response) => {
      this.config = response;
      this.setupStepper(response);
      this.startRiderConfig = this.commonService.getConfigForElementKey(response, 'Start Riders List Form').elementConfigList;
      this.fetchReferenceBooking();
    }, () => {
      this.isLoading = false;
      this.loadingError = true;
    });
  }

  fetchReferenceBooking() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.bookingId) {
        this.isLoading = true;
        this.commonBookingService.fetchBookingDetails({ bookingId: params.bookingId }).subscribe((response) => {
          this.referenceBooking = response;
          this.isLoading = false;
          let formDetails;
          formDetails = this.setReferenceBooking(response);
          this.setupForm(formDetails);
          if (this.createBookingService.isEditMode) {
            this.updateEditFieldStatus(response, this.cutoff);
          }
        }, () => {
          this.isLoading = false;
          this.setupForm();
        });
      } else {
        const requesterConfig = this.commonService.getConfigForElementKey(this.config, 'Requester Form');
        const paymentType = this.commonService.getConfigForElementKey(requesterConfig, 'paymentType');
        this.commonBookingService.getPaymentType(paymentType.config.defaultValue);
        this.isLoading = false;
        this.setupForm();
      }
    });
  }

  setupStepper(config: any) {
    this.stepperDetails = [
      {
        label: this.commonService.getConfigForElementKey(config, 'User Details Tab').config.displayName,
        completed: true
      },
      {
        label: this.commonService.getConfigForElementKey(config, 'Trip Details Tab').config.displayName
      },
      {
        label: this.commonService.getConfigForElementKey(config, 'Confirm Details Tab').config.displayName
      }
    ];
  }

  onTabClick = (step: number): void => {
    if (step < this.activeStep) {
      this.onStepChange(step);
    } else if (step === this.activeStep + 1) {
      this.onNextClick();
    } else if (this.activeStep === 0 && step === 2) {
      const userForm = this.formDetails.get('userDetails');
      const tripForm = this.formDetails.get('tripDetails');
      const riderArray = userForm.get('riders');
      if (userForm instanceof FormGroup && riderArray instanceof FormArray &&
        ((!userForm.valid && !userForm.disabled) || !riderArray)) {
        this.markFormGroupDirty(userForm);
        if (!userForm.get('riders')['length']) {
          this.toggleNoRiderError();
        }
      } else if (!tripForm.valid && userForm instanceof FormGroup) {
        this.markFormGroupDirty(this.formDetails);
        this.showNextStep();
      } else if (!this.stepperDetails[0].completed) {
        this.showNextStep();
      } else {
        this.stepperDetails[0].completed = true;
        this.stepperDetails[1].completed = true;
        this.onStepChange(2);
      }
    }
  }

  selectionChange(step: any) {
    // this.chooseFunctionCall();
    this.activeStep = step.selectedIndex;
    window.scroll(0, 0);
  }

  onStepChange = (step: number): void => {
    this.activeStep = step;
    window.scroll(0, 0);
  }

  showPreviousStep = (): void => {
    if(this.miscellConfig?.verifyEngagementCode && this.activeStep === 0){
      this.engagementForm?.reset();
    }
  }

  showNextStep = (): void => {
    this.stepperDetails[this.activeStep].completed = true;
    this.onStepChange(this.activeStep + 1);
    this.myStepper.next();
  }

  onNextClickAgain = () => {
            //  ( this.formDetails.get('userDetails').get('riders').length)
    if (this.activeStep === 0) {
      const userForm = this.formDetails.get('userDetails');
      const riderArray = userForm.get('riders');
      if (userForm instanceof FormGroup && riderArray instanceof FormArray) {
        if ((!userForm.valid && !userForm.disabled) || !riderArray.length) {
          this.markFormGroupDirty(userForm);
          if (!userForm.get('riders')['length']) {
            this.toggleNoRiderError();
          }
        } else {
          this.addNewRidersToTrip();
          this.showNextStep();
        }
      }
    } else if (this.activeStep === 1) {
      const tripForm = this.formDetails.get('tripDetails');
      const dateWise = tripForm.get('dateWise');
      if (dateWise instanceof FormArray && dateWise.length){
         const cabs = dateWise.at(0).get('cabs');
         if (cabs instanceof FormArray && cabs.length) {
           this.guardReq = cabs.at(0).get('guardReq').value;
         }
      }
      tripForm.updateValueAndValidity();
      if (tripForm instanceof FormGroup && !tripForm.valid) {

        this.createBookingService.createBackDatedBooking.subscribe(res => {
          res ? this.showNextStep() : this.markFormGroupDirty(tripForm);
        });
      } else {
        this.showNextStep();
      }
    }
  }

  onNextClick = () => {
    this.getPayerEmail();
    const request = {
      userEmail: this.selectedPayerEmail,
      buid: this.authService.user.buId,
    };

    this.createBookingService.getPaymentConfig().subscribe((res) => {
      if (res["autoDebitEnabled"] === true) {
        this.createBookingService.fetchCardDetails(request).subscribe((res) => {
          if (res.status == 200) {
            if (res.body &&
              (res.body[0]["defaultCard"] !== "" && res.body[0]["defaultCard"] !== null)) {
              this.onNextClickAgain();
            } else {
              // this.showAddButton = true;
              this.showErrorMsg = true;
            }
          } else {
            this.showErrorMsg = true;
          }
        });
      } else if (res["autoDebitEnabled"] === false) {
        this.onNextClickAgain();
      }
    }, (err) => {
      // alert('Sorry We cannot process this request.');
    });
  }

  chooseFunctionCall() {
    if(this.miscellConfig['verifyEngagementCode'] && !this.isAllGuest && this.activeStep === 0){
      this.toggleEngagementPopover();
    }
    if (this.formDetails.get('userDetails').get("requester") &&
      this.formDetails.get('userDetails').get("requester").get("paymentType").value === "Bill To Company") {
      this.paymentType = "Bill To Company";
      this.applyCheck();
    } else {
      this.paymentType = "Bill To User";
      this.applyCheck();
    }
  }

  applyCheck() {
    if (this.paymentType === "Bill To Company") {
      this.onNextClickAgain();
    } else {
      this.onNextClick();
    }
  }

  getPayerEmail() {
    let selectedPayerGuid = '';
    const riderDetails = this.formDetails.get('userDetails')["controls"].riders;
    const riderArray = riderDetails.value;
    const riderValues = riderDetails["controls"];
    let nonGuestType = false;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < riderValues.length; i++) {
      const riderType = riderValues[i].get('riderType').value;
      if (riderType !== 'Guest') {
        nonGuestType = true;
        break;
      }
    }
    this.selectedPayerEmail = '';
    this.loggedInUserEmail = this.authService.user.info.employee.emailId;

    if (!nonGuestType) {
      this.selectedPayerEmail = this.loggedInUserEmail;
      this.commonBookingService.getSelectedPayer(this.authService.user.employeeGuid);
    } else {
      if (riderValues.length === 1) {
        selectedPayerGuid = riderDetails["value"][0]["emplGuid"];
        this.selectedPayerEmail = riderDetails["controls"][0]["controls"]["email"]["value"];
      } else {
        this.commonBookingService.selectedPayer$.subscribe((res) => {
          selectedPayerGuid = res;
        });
        for (let j = 0; j < riderValues.length; j++) {
          if (selectedPayerGuid === riderValues[j]["value"]["emplGuid"]) {
            this.selectedPayerEmail = riderValues[j]["controls"]["email"]["value"];
          }
        }
      }
    }
    // Show ADD CARD DETAILS Button Check
    if (this.selectedPayerEmail == this.loggedInUserEmail) {
      this.showAddButton = true;
    } else {
      this.showAddButton = false;
    }

    // Show Choose Different Payer Button Check
    let count = 0;
    for (let j = 0; j < riderValues.length; j++) {
      if (riderValues[j]["controls"]["riderType"]["value"] === "Self" || "Firm Member") {
        count++;
      }
    }
    if (count > 1) {
      this.showDiffPayerButton = true;
    } else {
      this.showDiffPayerButton = false;
    }
  }

  dismissPopup() {
    this.showErrorMsg = false;
  }
  addNewRidersToTrip = () => {
    if (!this.createBookingService.newRiders.length) {
      return;
    }
    const ridersForm = this.formDetails.get('userDetails').get('riders');
    const riderMap = {};
    if (ridersForm instanceof FormArray) {
      const ridersArray = ridersForm.getRawValue();
      for (const rider of ridersArray) {
        riderMap[rider.travellerId] = {
          name: rider.travellerId,
          mobile: rider.mobile,
          boardingType: 'PickUp'
        };
      }
    }
    const dateFormArray = this.formDetails.get('tripDetails').get('dateWise');
    if (dateFormArray instanceof FormArray && dateFormArray.length) {
      for (const dateForm of dateFormArray.controls) {
        if (dateForm instanceof FormGroup) {
          const cabs = dateForm.get('cabs');
          if (cabs instanceof FormArray && cabs.length) {
            for (const cab of cabs.controls) {
              const stops = cab.get('stops');
              if (stops instanceof FormArray) {
                const start = stops.at(0);
                const startRiders = start instanceof FormGroup && start.get('riders');
                if (startRiders instanceof FormArray) {
                  for (const riderId of this.createBookingService.newRiders) {
                    const rider = riderMap[riderId];
                    const riderFormGroup: any = new FormGroup({});
                    this.constructForm(riderFormGroup, this.startRiderConfig);
                    riderFormGroup.patchValue(rider);
                    if (!riderFormGroup.get('boardingType').value) {
                      riderFormGroup.get('boardingType').setValue('PickUp');
                    }
                    riderFormGroup.get('boardingType').disable();
                    startRiders.push(riderFormGroup);
                  }
                }
              }
            }
          }
        }
      }
    }
    this.createBookingService.newRiders = [];
  }

  cancelRequestView = (): void => {
    this.toggleExitPopup();
  }

  toggleExitPopup = (): void => {
    this.isExitPopupVisible = !this.isExitPopupVisible;
  }

  navigateToProfile() {
    this.router.navigate([`/profile`]);
  }

  exitView = (): void => {
    this.location.back();
  }

  toggleNoRiderError = () => {
    this.isNoRiderErrorVisible = !this.isNoRiderErrorVisible;
  }

  toggleBookingCreationError = () => {
    this.isBookingCreationError = !this.isBookingCreationError;
  }

  onSubmit() {
    if (this.createBookingService.isEditMode) {
      this.updateBooking();
    } else {
      if (this.commonService.workflowConfig['managerApproval']) {
        if (this.approvalEmail) {
          this.createBooking();
        } else {
          if (this.dialogOpen) {
            this.createBooking();
          } else {

              this.createBooking();

          }
        }
      } else {
        this.createBooking();
      }
    }

  }

  createBooking() {


    if (this.cutoff && !this.utilService.checkIfDateTimeBetween(this.cutoff.start, this.cutoff.end)) {
      this.bookingCutoffMessage = this.cutoff.errorMessage;
    } else {
      this.isLoading = true;
      const request = this.createBookingService.convertFormToRequest(this.formDetails);
      request.client = this.authService.client.client;
      this.createBookingService.createBooking(request).subscribe((data: any) => {
        this.isLoading = false;
        this.router.navigate(['bookings'], { queryParams: { createdRequest: data[0].requestId } });
        this.createBookingService.submittedDocId.next('');
      }, (data: any) => {
        this.isLoading = false;
        this.isBookingCreationError = true;
        this.bookingCreationErrorMsg = data.error.message || 'There was a problem in creating your booking.';
        // this.toggleBookingCreationError();
      });
    }
    this.createBookingService.showCreateBookingButton.next(true);
  }
  showBookingFail(){
    this.isBookingCreationError = false;
    this.activeStep = 0;
    this.exitCreateBooking();
  }

  updateBooking() {
    if (this.cutoff && !this.utilService.checkIfDateTimeBetween(this.cutoff.start, this.cutoff.end)) {
      this.bookingCutoffMessage = this.cutoff.errorMessage;
    } else {
      this.isLoading = true;
      const request = this.createBookingService.convertFormToRequest(this.formDetails);
      request.modifier = {
        buid: this.authService.user.buId,
        emplGuid: this.authService.user.employeeGuid
      };
      this.createBookingService.addRiderIdToEndStop(request.spotBookings[0], this.referenceBooking);
      const booking = Object.assign({}, this.referenceBooking, request, request.spotBookings[0]);
      if (!booking.payerGuid) {
        booking['payer'] = null;
      }
      delete booking.spotBookings;
      this.createBookingService.updateBooking({ bookingId: this.referenceBooking.bookingId }, booking).subscribe((data: any) => {
        this.isLoading = false;
        this.router.navigate(['bookings'], { queryParams: { updatedBooking: data.bookingId } });
      }, (data: any) => {
        this.isLoading = false;
        this.bookingCreationErrorMsg = data.error.message || 'There was a problem in updating your booking.';
        this.toggleBookingCreationError();
      });
    }
  }
  submitNewBooking(){
    if(this.commonService.workflowConfig){
      if (this.managerBookingPopup && this.commonService.workflowConfig['customReportingManager']){
        this.customManagerPopup = true;
        this.createBookingService.showWarningDialog(true);
      } else {
        this.commonService.workflowConfig['customReportingManager'] ? this.onSubmit() : this.showConfirmBookingPopup = true;
      }
    }
  }

  submitBookingWithManager(event)
  {
     if (event)
     {
      this.customManagerPopup = false;
      this.onSubmit();
     }
  }

  exitCreateBooking(){
    this.showConfirmBookingPopup = false;
    // this.router.navigate(['bookings/bookings-view'])
  }
  setReferenceBooking(booking: any) {

    this.filteredConfig = {};

    // requester form
    const requester = new FormGroup({});
    this.filteredConfig.requesterConfig = this.commonService.getConfigForElementKey(this.config, 'Requester Form').elementConfigList;

    this.constructForm(requester, this.filteredConfig.requesterConfig, (field) => {
      if (field.elementKey === 'RequesterSearch') {
        return true;
      }
      return false;
    });
    requester.addControl('emplGuid', new FormControl(booking.requester.emplGuid));
    requester.patchValue(booking.requester);
    const paymentFormControl = requester.get('paymentType');
    this.commonBookingService.getPaymentType(booking.paymentType);
    if (paymentFormControl instanceof FormControl) {
      paymentFormControl.setValue(booking.paymentType);
    }

    if (this.createBookingService.isEditMode) {
      requester.disable();
    }
    // rider form
    const riderMap: any = {};
    if (booking.stops){
      for (const stop of booking.stops) {
        for (const rider of stop.riders) {
          if (!riderMap[rider.personId]) {
            riderMap[rider.personId] = rider;
          }
        }
      }
    }


    this.filteredConfig.riderConfig = this.commonService.getConfigForElementKey(this.config, 'Rider Form').elementConfigList;
    const riderArray = Object.values(riderMap);
    const riderFormArray = new FormArray([]);
    for (const rider of riderArray) {
      const riderObj: any = rider;
      const riderForm: any = new FormGroup({
        travellerId: new FormControl(riderObj.personId),
        payerGuid: new FormControl(''),
        officeGuid: new FormControl('')
      });
      this.constructForm(riderForm, this.filteredConfig.riderConfig, (field) => {
        if (field.elementKey === 'RiderSearch' || field.config.elementType === 'button' || field.elementKey === 'Rider Serial Number') {
          return true;
        }
        return false;
      });
      if (riderObj.emplGuid) {
        // riderForm.disable();
        riderForm.get('alternateMobile')?.enable()
        // riderObj.riderType = 'Firm Member';


        if (riderObj.emplGuid === this.authService.user.employeeGuid) {
          // riderObj.riderType = rider.riderType;
          // riderObj.riderTypeId = 'Self'
        }
      }
      riderForm.addControl('emplGuid', new FormControl(''));
      if (booking.payer && riderObj.emplGuid === booking.payer.emplGuid) {
        riderForm.patchValue({ payerGuid: booking.payer.emplGuid });
      }
      riderForm.addControl('designation', new FormControl(''));
      riderForm.patchValue(riderObj);
      riderForm.patchValue({ officeGuid: riderObj.officeGuid });
      riderFormArray.push(riderForm);
    }

    // trip details form
    const tripDetailsConfig = [];
    const dateWiseConfig = [];
    const cabConfig = [];
    const tripConfig = this.commonService.getConfigForElementKey(this.config, 'Trip Details Form').elementConfigList;
    for (const element of tripConfig) {
      const key = element.elementKey;
      if (key === 'DateSelection' || key === 'Date Toggle') {
        tripDetailsConfig.push(element);
      } else if (key === 'CabCount' || key === 'CabToggle') {
        dateWiseConfig.push(element);
      } else {
        cabConfig.push(element);
      }
    }

    this.filteredConfig.tripDetailsConfig = tripDetailsConfig;
    this.filteredConfig.dateWiseConfig = dateWiseConfig;
    this.filteredConfig.cabConfig = cabConfig;

    // date wise from
    let bookingDate = this.utilService.getMoment(booking.startTime);
    const now = this.utilService.getMoment();
    if (bookingDate.isBefore(now)) {
      bookingDate = now;
    }
    const dates = [bookingDate];
    const tripDetailsForm: any = new FormGroup({});
    this.constructForm(tripDetailsForm, tripDetailsConfig);
    tripDetailsForm.get('DateSelection').setValue(dates);
    const dateWiseFormArray = new FormArray([]);
    const cabsFormArray = new FormArray([]);
    const dateCardForm = new FormGroup({
      dates: new FormControl(dates),
      cabs: cabsFormArray
    });
    this.constructForm(dateCardForm, dateWiseConfig);
    if (this.createBookingService.isEditMode) {
      dateCardForm.get('CabCount').disable();
    }
    dateWiseFormArray.push(dateCardForm);

    // cab form
    let cabForm: any = new FormGroup({});
    this.constructForm(cabForm, cabConfig);
    booking.vendor = '';
    const vehicleTypeConfig = this.commonService.getConfigForElementKey(cabConfig, 'vehicleType');
    if (booking.vehicleType && vehicleTypeConfig && vehicleTypeConfig.config.values.indexOf(booking.vehicleType) === -1) {
      booking.otherVehicleType = booking.vehicleType;
      if (!this.designationConfig?.designationBasedCabType) {
        booking.vehicleType = 'Other';
      }
    }
    cabForm.patchValue(booking);
    // cabsFormArray.push(cabForm);

    cabForm.addControl('multiDays', new FormArray([]));
    cabForm = this.formBuilder.group({
        ...cabForm.controls,
        multiDays: this.formBuilder.array([])
      });
    this.populateMultidays(cabForm);
    cabsFormArray.push(cabForm);

    // add start point
    this.filteredConfig.startConfig = this.commonService.getConfigForElementKey(this.config, 'Start Address Form').elementConfigList;
    this.filteredConfig.stopConfig = this.commonService.getConfigForElementKey(this.config, 'Stop Address Form').elementConfigList;
    this.filteredConfig.endConfig = this.commonService.getConfigForElementKey(this.config, 'End Address Form').elementConfigList;
    // tslint:disable-next-line: max-line-length
    this.filteredConfig.startRiderConfig = this.commonService.getConfigForElementKey(this.config, 'Start Riders List Form').elementConfigList;
    this.filteredConfig.stopRiderConfig = this.commonService.getConfigForElementKey(this.config, 'Stop Riders List Form').elementConfigList;
    let stops;
    if (booking.stops?.length){
      stops = booking?.stops.sort((stop1, stop2) => {
      if (stop1.priorityOrder > stop2.priorityOrder) {
        return 1;
      } else if (stop1.priorityOrder < stop2.priorityOrder) {
        return -1;
      } else {
        return 0;
      }
    });
    if (booking.spotBookingType === 'Airport PickUp') {
      stops[0].isAirport = true;
    } else if (booking.spotBookingType === 'Airport Drop' || booking.spotBookingType === 'Airport To Airport') {
      stops[booking.stops.length - 1].isAirport = true;
    }
    else if(booking.spotBookingType === 'Bus Station Pickup' || booking.spotBookingType === 'Railway Station Pickup')
    {
      stops[0].isBusRailway = true;
    }
    else if(booking.spotBookingType === 'Bus Station Drop'|| booking.spotBookingType === 'Railway Station Drop')
    {
      stops[booking.stops.length - 1].isBusRailway = true;
    }

    const stopFormArray = new FormArray([]);

    stops.forEach((stop, stopIndex) => {
      const stopForm = new FormGroup({});
      if (stopIndex === 0) {
        this.constructForm(stopForm, this.filteredConfig.startConfig);
      } else if (stopIndex === stops.length - 1) {
        this.constructForm(stopForm, this.filteredConfig.endConfig);
        if (booking.spotBookingType && booking.spotBookingType.toLowerCase() === 'cab at disposal') {
          stopForm.get('address').clearValidators();
        }
      } else {
        this.constructForm(stopForm, this.filteredConfig.stopConfig);
      }
      let ridersFormArray;
      if (stopIndex < stops.length - 1) {
        ridersFormArray = new FormArray([]);
        stop.riders.forEach((rider, riderIndex) => {
          const riderObj = {
            name: rider.personId,
            mobile: rider.mobile,
            boardingType: rider.boardingType
          };
          const riderForm = new FormGroup({});
          if (stopIndex === 0) {
            this.constructForm(riderForm, this.filteredConfig.startRiderConfig);
          } else {
            this.constructForm(riderForm, this.filteredConfig.stopRiderConfig);
          }
          riderForm.addControl('riderId', new FormControl(rider.riderId));
          riderForm.patchValue(riderObj);
          ridersFormArray.push(riderForm);
        });
        stopForm.setControl('riders', ridersFormArray);
      }
      if (stop.time) {
        stopForm.setControl('time', new FormControl(this.utilService.converDateTimeToDisplayTime(stop.time)));
      }
      if (stop.geoArea) {
        stopForm.setControl('geoArea', new FormControl(stop.geoArea));
      }
      if (stop.address) {
        stopForm.setControl('address', new FormControl({
          isSaved: true,
          address: stop.address,
          addressType: stop.addressType,
          geoArea: stop.geoArea,
          geoCord: stop.geoCord,
          isAirport: stop?.isAirport|| false,
          isBusRailway:stop?.isBusRailway|| false
        }));
      }
      if (this.createBookingService.isEditMode) {
        stopForm.addControl('id', new FormControl(stop.id));
      }
      stopFormArray.push(stopForm);

    });
    cabForm.addControl('stops', stopFormArray);
  }


    


    const formDetails = new FormGroup({
      userDetails: new FormGroup({
        requester,
        riders: riderFormArray
      }),
      tripDetails: new FormGroup({
        tripDetails: tripDetailsForm,
        dateWise: dateWiseFormArray
      })
    });

    return formDetails;

  }

  updateEditFieldStatus(booking, editConfig) {
    this.createBookingService.getBookingEditConfig(booking, editConfig).subscribe((bookingEditConfig) => {
      this.setFieldStates(bookingEditConfig);
      this.bookingEditConfig = bookingEditConfig;
    });

  }

  setFieldStates(editConfig: any) {

    const requesterForm = this.formDetails.get('userDetails').get('requester');
    if (requesterForm instanceof FormGroup) {
      this.evaluateFieldStates(
        requesterForm,
        this.filteredConfig.requesterConfig,
        editConfig
      );
    }

    const riderArray = this.formDetails.get('userDetails').get('riders');
    if (riderArray instanceof FormArray) {
      this.evaluateFieldStates(
        riderArray,
        this.filteredConfig.riderConfig,
        editConfig
      );
    }

    const tripDetails = this.formDetails.get('tripDetails').get('tripDetails');
    if (tripDetails instanceof FormGroup) {
      this.evaluateFieldStates(
        tripDetails,
        this.filteredConfig.tripDetailsConfig,
        editConfig
      );
    }

    const dateCards = this.formDetails.get('tripDetails').get('dateWise');
    if (dateCards instanceof FormArray) {
      const cabs = dateCards.at(0).get('cabs');
      if (cabs instanceof FormArray) {
        const cab: any = cabs.at(0);

        if (cab instanceof FormGroup) {
          this.evaluateFieldStates(
            cab,
            this.filteredConfig.cabConfig,
            editConfig
          );
        }
        const stops = cab.get('stops');
        if (stops instanceof FormArray) {
          for (let stopIndex = 0; stopIndex < stops.length; stopIndex++) {
            const stop = stops.at(stopIndex);
            const stopConfig = stopIndex === 0 ? this.filteredConfig.startConfig
              : stopIndex === stops.length - 1 ? this.filteredConfig.endConfig
                : this.filteredConfig.stopConfig;

            if (stop instanceof FormGroup) {
              this.evaluateFieldStates(
                stop,
                stopConfig,
                editConfig
              );
            }

            const riders = stop.get('riders');
            const riderConfig = stopIndex === 0 ? this.filteredConfig.startRiderConfig
              : this.filteredConfig.stopRiderConfig;
            if (riders instanceof FormArray) {
              this.evaluateFieldStates(
                riders,
                riderConfig,
                editConfig
              );
            }
          }
        }
      }
    }
  }
  populateMultidays(cab) {

    const multidaysFormArray = cab.get('multiDays') as FormArray;
    if (this.referenceBooking.multiDays && this.referenceBooking.multiDays.length > 0){
      this.referenceBooking.multiDays.forEach(dayEntry => {
        const dayFormGroup = this.formBuilder.group({
          day: dayEntry.day,
          stops: this.convertStopsToFormArray(dayEntry.stops)
        });

        multidaysFormArray.push(dayFormGroup);
      });
    }


  }
  convertStopsToFormArray(stops: any[]): FormArray {
    const stopsFormArray = this.formBuilder.array([]);
    stops.forEach(stop => {
      const stopFormGroup: any = this.formBuilder.group({
        id: stop.id,
        address: stop.address,
        geoCord: stop.geoCord,
        geoArea: stop.geoArea,
        addressType: stop.addressType,
        time: stop.time,
        pointType: stop.pointType,
        priorityOrder: stop.priorityOrder,
        riders: stop.riders,
        count: stop.count
      });
      stopsFormArray.push(stopFormGroup);
    });
    return stopsFormArray;
  }

  onRequesterSelect(ev) {
    this.requester = ev.value;
  }

  cancelBooking(event) {
    event.stopPropagation();
    alert('ddddd');
  }

  checkConfirmationPopup(){
     this.customReportingManager = this.commonService.workflowConfig['customReportingManager'];
     this.customReportingManager ? this.onSubmit() : this.showConfirmBookingPopup = true;

  }

  needMangerApproval(event)
  {
    if (event) {
      this.managerBookingPopup = true;
    }
  }
  closeDialog(event)
  {
    this.customManagerPopup = false;
  }

  openDrawer() {
    const drawerRef = this.drawerSvc.show(
      BookingInstructionComponent,
      { data: '',
       width: "422px" }
    );
    drawerRef.afterClosed.subscribe();
  }

  toggleEngagementPopover(){
    this.showEngagementPopover = !this.showEngagementPopover;
  }

  ngOnDestroy() {
    this.commonService.setValue('0');
    this.commonBookingService.updateHomeAddressesOfRiders(null);
    this.commonBookingService.getSelectedPayer(null);
    this.createBookingService.newRiders = [];
    this.createBookingService.isEditMode = false;
    if (this.createBookingService.editConfigTimer) {
      clearTimeout(this.createBookingService.editConfigTimer);
      this.createBookingService.editConfigTimer = null;
    }

    this.destroy$.next();
    this.destroy$.complete();
  }
}
